/**
 * Skill marketplace (Rocky's Armory) and the Cheetah expert-booking page.
 * Keys must match ../en/skills.ts.
 * Category names (DataRetriever, Hedwig, Cheetah, IVT, ...) are brands and are not here; each
 * category's description under `categories` is keyed by its catalog category
 * (SkillMarketplace CATEGORIES[].apiCategory).
 * Expert profiles are static data with their own zh/en copies (cheetahExperts.ts).
 */
const skills = {
  hero: {
    title: 'Rocky 技能库',
    count: '已上线 <highlight>{{n}} 个技能</highlight>！',
    imageAlt: 'Rocky 技能库插图',
  },
  tabs: {
    recommend: '推荐',
    mySkills: '我的技能',
  },
  categories: {
    dataretriever: '从多个数据源获取并汇总数据。',
    hedwig: '自动化消息流程与通知推送。',
    cheetah:
      '内部专家预约服务：按需匹配合适的专家，一键预约，全程跟踪协作进展。',
    ivt: '行业解决方案：浏览 Solution Map、Storyline、Asset 和 Motion，助力行业销售。',
    campaign_copilot: '营销活动编排：圈选受众、个性化邮件、创建 Octopus 活动与效果分析。',
    event_insights: '活动洞察：活动前后的数据分析报告。',
  },
  search: '搜索技能',
  loading: '正在加载技能…',
  loadFailed: '加载技能失败：{{message}}',
  empty: '没有找到技能。',
  untitled: '未命名',
  generalTag: '通用',
  card: {
    showDetails: '查看详情',
  },
  modal: {
    close: '关闭',
    noDescription: '暂无描述。',
    noPreview: '暂无预览',
    cancel: '取消',
    processing: '处理中…',
    equip: '装备技能',
    unequip: '卸下技能',
  },
  cheetah: {
    back: '返回 Workspace',
    introLabel: 'Cheetah 介绍',
    intro: '想带技术大佬一起拜访客户？Cheetah 为您提供标准化的专家预约服务，您可以按需求匹配资源、在线完成预约、跟进拜访流程。',
    revisit: '预约回访',
    book: '一键预约',
    revisitPrompt: '我想安排一次回访。',
    bookPrompt: '我想预约一位技术专家拜访客户。',
    expertsLabel: '技术专家',
    expertTitle: '对外头衔：{{title}}',
    phoneTool: '{{name}} PhoneTool',
    modalTitle: '专家信息',
    modalLabel: '专家信息',
    close: '关闭',
  },
};

export default skills;
